(function () {

  const EXTRAS_VARIANTS = {
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|up to 8 people (base price)": 42477947093082,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|9 people": 42477955186778,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|10 people": 42477955219546,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|11 people": 42477955252314,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|12 people": 42477955285082,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|13 people": 42477955317850,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|14 people": 42477955350618,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|15 people": 42477955383386,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|16 people": 42477970292826,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|17 people": 42477970325594,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|18 people": 42477970358362,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|19 people": 42477970391130,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|20 people": 42477970423898,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)": 42477955416154,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|9 people": 42477955448922,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|10 people": 42477955481690,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|11 people": 42477955514458,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|12 people": 42477955547226,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|13 people": 42477955579994,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|14 people": 42477955612762,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|15 people": 42477955645530,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|16 people": 42477970456666,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|17 people": 42477970489434,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|18 people": 42477970522202,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|19 people": 42477970554970,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|20 people": 42477970587738,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)": 42477955678298,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people": 42477955711066,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people": 42477955743834,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people": 42477955776602,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people": 42477955809370,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people": 42477955842138,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people": 42477955874906,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people": 42477955907674,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people": 42477970620506,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people": 42477970653274,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people": 42477970686042,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people": 42477970718810,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people": 42477970751578,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|up to 8 people (base price)": 42477947224154,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|9 people": 42477955940442,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|10 people": 42477955973210,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|11 people": 42477956005978,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|12 people": 42477956038746,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|13 people": 42477956071514,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|14 people": 42477956104282,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|15 people": 42477956137050,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|16 people": 42477970784346,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|17 people": 42477970817114,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|18 people": 42477970849882,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|19 people": 42477970882650,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|20 people": 42477970915418,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)": 42477956169818,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|9 people": 42477956202586,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|10 people": 42477956235354,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|11 people": 42477956268122,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|12 people": 42477956300890,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|13 people": 42477956333658,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|14 people": 42477956366426,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|15 people": 42477956399194,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|16 people": 42477970948186,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|17 people": 42477970980954,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|18 people": 42477971013722,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|19 people": 42477971046490,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|20 people": 42477971079258,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)": 42477956431962,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people": 42477956464730,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people": 42477956497498,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people": 42477956530266,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people": 42477956563034,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people": 42477956595802,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people": 42477956628570,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people": 42477956661338,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people": 42477971112026,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people": 42477971144794,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people": 42477971177562,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people": 42477971210330,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people": 42477971243098,
  };

  const EXTRAS_PRICES = {
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|up to 8 people (base price)": 0,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|9 people": 1600,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|10 people": 3200,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|11 people": 4800,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|12 people": 6400,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|13 people": 8000,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|14 people": 9600,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|15 people": 11200,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|16 people": 16800,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|17 people": 18400,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|18 people": 20000,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|19 people": 21600,
    "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|20 people": 23200,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)": 6400,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|9 people": 8800,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|10 people": 11200,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|11 people": 13600,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|12 people": 16000,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|13 people": 18400,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|14 people": 20800,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|15 people": 23200,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|16 people": 29600,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|17 people": 32000,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|18 people": 34400,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|19 people": 36800,
    "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|20 people": 39200,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)": 9600,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people": 12400,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people": 15200,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people": 18000,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people": 20800,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people": 23600,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people": 26400,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people": 29200,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people": 36000,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people": 38800,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people": 41600,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people": 44400,
    "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people": 47200,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|up to 8 people (base price)": 6400,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|9 people": 8800,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|10 people": 11200,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|11 people": 13600,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|12 people": 16000,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|13 people": 18400,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|14 people": 20800,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|15 people": 23200,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|16 people": 31600,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|17 people": 34000,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|18 people": 36400,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|19 people": 38800,
    "yes - 90 minutes of art time|no - just we will leave after the art portion|20 people": 41200,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)": 12800,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|9 people": 16000,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|10 people": 19200,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|11 people": 22400,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|12 people": 25600,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|13 people": 28800,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|14 people": 32000,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|15 people": 35200,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|16 people": 44400,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|17 people": 47600,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|18 people": 50800,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|19 people": 54000,
    "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|20 people": 57200,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)": 16000,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people": 19600,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people": 23200,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people": 26800,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people": 30400,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people": 34000,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people": 37600,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people": 41200,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people": 50800,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people": 54400,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people": 58000,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people": 61600,
    "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people": 65200,
  };

  const UPGRADE_VARIANT_ID  = 43176665677914;
  const UPGRADE_PROJECTS    = ['clay', 'painting', 'besties'];
  const BASE_EXTRAS_KEY     = 'no - 60 minutes for the art project is good!|no - just we will leave after the art portion|up to 8 people (base price)';
  const PARENT_STAY_HANDLE  = 'kids-party-parent-helper-observer';

  let parentStayVariantId   = null;
  let parentStayPriceCents  = 500;

  async function loadParentStayVariant() {
    try {
      const res     = await fetch('/products/' + PARENT_STAY_HANDLE + '.js');
      const product = await res.json();
      if (product.variants && product.variants.length > 0) {
        parentStayVariantId  = product.variants[0].id;
        parentStayPriceCents = product.variants[0].price;
      }
    } catch (err) {
      console.error('Parent stay lookup error:', err);
    }
  }

  function getParticipantCount(val) {
    if (!val || val.startsWith('up to 8')) return 8;
    const m = val.match(/^(\d+)/);
    return m ? parseInt(m[1]) : 8;
  }

  function init() {
    const block = document.getElementById('party-addons-block');
    if (!block) return;

    const projectSel         = document.getElementById('party-project-type');
    const artTimeSel         = document.getElementById('party-art-time');
    const partyAfterSel      = document.getElementById('party-time-after');
    const participSel        = document.getElementById('party-participants');
    const upgradeNotice      = document.getElementById('upgrade-notice');
    const errorEl            = document.getElementById('party-error');
    const subtotalBox        = document.getElementById('party-subtotal');
    const subtotalBase       = document.getElementById('subtotal-base');
    const subtotalUpgradeRow = document.getElementById('subtotal-upgrade-row');
    const subtotalExtrasRow  = document.getElementById('subtotal-extras-row');
    const subtotalExtras     = document.getElementById('subtotal-extras');
    const subtotalParentRow  = document.getElementById('subtotal-parent-stay-row');
    const subtotalParent     = document.getElementById('subtotal-parent-stay');
    const subtotalTotal      = document.getElementById('subtotal-total');
    const basePriceCents     = parseInt(block.dataset.basePrice) || 0;

    const parentStayYes = document.getElementById('parent-stay-yes');
    const hasParentStay = !!parentStayYes;

    if (hasParentStay) loadParentStayVariant();

    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function extrasKey() {
      return `${artTimeSel.value}|${partyAfterSel.value}|${participSel.value}`;
    }

    function getParentStayChoice() {
      if (!hasParentStay) return 'no';
      const checked = document.querySelector('input[name="parent-stay"]:checked');
      return checked ? checked.value : 'no';
    }

    function updateUI() {
      const proj         = projectSel.value;
      const needsUpgrade = UPGRADE_PROJECTS.includes(proj);
      upgradeNotice.style.display = needsUpgrade ? 'block' : 'none';

      const key         = extrasKey();
      const extrasCents = EXTRAS_PRICES[key] ?? 0;
      const parentYes   = getParentStayChoice() === 'yes';
      const count       = getParticipantCount(participSel.value);
      const parentCents = parentYes ? parentStayPriceCents * (count - 1) : 0;

      if (proj) {
        subtotalBox.style.display  = 'block';
        subtotalBase.textContent   = fmt(basePriceCents);
        subtotalUpgradeRow.style.display = needsUpgrade ? 'flex' : 'none';
        subtotalExtrasRow.style.display  = extrasCents > 0 ? 'flex' : 'none';
        subtotalExtras.textContent       = fmt(extrasCents);

        if (subtotalParentRow) {
          subtotalParentRow.style.display = parentYes ? 'flex' : 'none';
          if (subtotalParent) {
            subtotalParent.textContent = fmt(parentCents) + ' (' + (count - 1) + ' \u00d7 ' + fmt(parentStayPriceCents) + ')';
          }
        }

        subtotalTotal.textContent = fmt(
          basePriceCents +
          (needsUpgrade ? 4000 : 0) +
          extrasCents +
          parentCents
        );
      } else {
        subtotalBox.style.display = 'none';
      }
    }

    [projectSel, artTimeSel, partyAfterSel, participSel].forEach(el => {
      el.addEventListener('change', updateUI);
    });

    if (hasParentStay) {
      document.querySelectorAll('input[name="parent-stay"]').forEach(r => {
        r.addEventListener('change', updateUI);
      });
    }

    document.addEventListener('submit', async function (e) {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      errorEl.style.display = 'none';
      errorEl.textContent   = '';

      // Validate: project type
      const proj = projectSel.value;
      if (!proj) {
        errorEl.textContent = 'Please select a project type before adding to cart.';
        errorEl.style.display = 'block';
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }

      // Validate: observer policy checkbox
      const acknowledgeBox = document.getElementById('party-observer-acknowledge');
      if (acknowledgeBox && !acknowledgeBox.checked) {
        errorEl.textContent = 'Please confirm you have read and understood the adult observer policy before adding to cart.';
        errorEl.style.display = 'block';
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }

      const baseVariantId = form.querySelector('[name="id"]')?.value;
      if (!baseVariantId) {
        errorEl.textContent = 'Could not determine party variant. Please refresh and try again.';
        errorEl.style.display = 'block';
        return;
      }

      const linkedTo = String(baseVariantId);
      const projLabels = { clay: 'Clay', painting: 'Painting', 'oven-bake': 'Oven-Bake Clay', besties: 'Besties', undecided: 'Undecided' };
      const items = [];

      // 1. Main party booking (no _linked_to — this IS the base)
      items.push({
        id: parseInt(baseVariantId),
        quantity: 1,
        properties: { 'Project Type': projLabels[proj] || proj }
      });

      // 2. Project upgrade — linked to base
      if (UPGRADE_PROJECTS.includes(proj)) {
        items.push({
          id: UPGRADE_VARIANT_ID,
          quantity: 1,
          properties: { '_linked_to': linkedTo }
        });
      }

      // 3. Extras add-on — linked to base
      const key = extrasKey();
      if (key !== BASE_EXTRAS_KEY) {
        const extrasId = EXTRAS_VARIANTS[key];
        if (extrasId) {
          items.push({
            id: extrasId,
            quantity: 1,
            properties: { '_linked_to': linkedTo }
          });
        }
      }

      // 4. Parent stay add-on — linked to base
      if (hasParentStay && getParentStayChoice() === 'yes') {
        if (!parentStayVariantId) await loadParentStayVariant();
        if (parentStayVariantId) {
          const count = getParticipantCount(participSel.value);
          items.push({
            id: parentStayVariantId,
            quantity: count - 1,
            properties: { '_linked_to': linkedTo }
          });
        }
      }

      try {
        const res  = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await res.json();

        if (!res.ok) {
          errorEl.textContent = data.description || 'There was a problem adding to cart. Please try again.';
          errorEl.style.display = 'block';
          return;
        }

        if (window.miniMakeUpsell && window.miniMakeUpsell.pendingShow) {
  window.miniMakeUpsell.pendingShow();
} else {
  window.location.href = '/cart';
};
      } catch (err) {
        errorEl.textContent = 'Network error. Please check your connection and try again.';
        errorEl.style.display = 'block';
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();